import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule, ReactiveFormsModule ,FormBuilder, Validators } from '@angular/forms';
// import { Api } from '../services/api';
import { CommonModule } from '@angular/common';
import { SessionService } from '../services/session-service';
import { NotificationService } from '../services/notification-service';
import { Auth } from '../services/auth';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCircleAlert, lucideSearch } from '@ng-icons/lucide';
import { matArrowBackOutline } from '@ng-icons/material-symbols/outline';

@Component({
  selector: 'app-status-check-flow',
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule, RouterLink, NgIcon, HlmButtonImports, HlmSpinnerImports, HlmCardImports, HlmFieldImports, HlmInputImports, HlmAlertImports],
  templateUrl: './status-check-flow.html',
  styleUrls: ['./status-check-flow.css'],
  providers: [provideIcons({ lucideCircleAlert, lucideSearch, matArrowBackOutline })]
  // host: {
  //   class: 'block',
  // },
})
export class StatusCheckFlowComponent implements OnInit {
  private authService = inject(Auth);
  private sessionService = inject(SessionService);
  private router = inject(Router);
  private fb = inject(FormBuilder);
  private notificationService = inject(NotificationService);

  // phoneNumber: string = '';
  // serialCode: string = '';
  errorMessage = signal<string>('');
  isLoading = signal<boolean>(false);

  loginForm = this.fb.group({
      phone: ['',Validators.required],
      serial:['',Validators.required]
    })
  constructor() {}

  ngOnInit(): void {
  }

  async onSubmit() {
    if (this.loginForm.invalid || this.isLoading()) return;

    this.errorMessage.set('');
    this.isLoading.set(true)
    try {
      const isAuthenticated = await this.authService.login(`${this.loginForm.get('phone')?.value}`, `${this.loginForm.get('serial')?.value}`);
      this.isLoading.set(false)
      console.log('isAuthenticated', isAuthenticated)
      if (isAuthenticated) {

        this.sessionService.setSession({ phoneNumber: this.loginForm.get('phone')?.value, serial:this.loginForm.get('serial')?.value});
        this.notificationService.notify('Welcome', 'success', { duration: 3000, position: 'top-right' });
        this.router.navigate(['/dashboard/membership-form']);
      } else {
        console.log('Invalid credentials');
        this.isLoading.set(false)
        this.errorMessage.set('Invalid credentials');
      }
    } catch (error) {
      this.isLoading.set(false)
      this.errorMessage.set('An error occurred');
      // this.notificationService.presentToast(this.errorMessage,3000,"bottom",'danger')
    }
  }


}
